import { IFeaturedAd } from '../featured-ad';
import { IHDYHAU } from '../hdyhau';

export enum BLOCK_TYPES {
    FEATURED_AD,
    HDYHAU,
}

export type IBlock<TType extends BLOCK_TYPES, TContent> = {
    type: TType;
    content: TContent;
};

export type IFeaturedAdBlock = IBlock<BLOCK_TYPES.FEATURED_AD, IFeaturedAd>;

export type IHDYHAUBlock = IBlock<BLOCK_TYPES.HDYHAU, IHDYHAU>;

export type IPageBlock = IFeaturedAdBlock | IHDYHAUBlock;

export interface IPage {
    blocks: IPageBlock[];
}

export interface IPageFetcher {
    fetch: (id: string) => Promise<IPage>;
}

export async function getPage (id: string, client: IPageFetcher): Promise<IPage> {
    return client.fetch(id);
}
